import AddressForm from "@/common/components/AddressForm";
import useAddressForm from "@/common/hooks/useAddressForm";
import { AddressValidationSchema } from "@/common/schemas/address.schema";
import { AddressData } from "@/common/types/address";
import { RequestedReview } from "@/features/establishmentLeadsFunnel/components/RequestedReview";
import { ReviewButtons } from "@/features/establishmentLeadsFunnel/components/ReviewButtons";
import { PrivateCompanyLeadsFunnelUpdateValidationSchema } from "@/features/privateCompanyLeadsFunnel/schemas/update.schema";
import { LastReview } from "@/features/privateCompanyLeadsFunnel/types/privateCompanyLead";
import { UseMutateFunction } from "@tanstack/react-query";
import { FieldErrors, UseFormSetError, UseFormSetValue } from "react-hook-form";

interface AddressSectionProps {
  address?: AddressData & { last_review: LastReview; };
  setValue?: UseFormSetValue<PrivateCompanyLeadsFunnelUpdateValidationSchema>;
  setError?: UseFormSetError<PrivateCompanyLeadsFunnelUpdateValidationSchema>;
  errors: FieldErrors<PrivateCompanyLeadsFunnelUpdateValidationSchema>;
  submit?: () => void;
  approveAddressLead?: UseMutateFunction<void, Error, { description?: string; } | undefined, unknown>;
  declineAddressLead?: UseMutateFunction<void, Error, { description?: string; } | undefined, unknown>;
  disabled?: boolean;
}

export const AddressSection = ({
  address,
  errors,
  submit,
  approveAddressLead,
  declineAddressLead,
  disabled,
}: AddressSectionProps) => {
  const addressForm = useAddressForm<PrivateCompanyLeadsFunnelUpdateValidationSchema>({
    path: 'address_attributes',
    initialAddress: address as AddressData || {},
    onAddressChange: (_, isValid) => {
      if (!disabled && isValid) {
        submit?.();
      }
    },
    disabled,
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between">
        <p className="text-[18px] font-bold">Endereço</p>
        {(approveAddressLead && declineAddressLead) && (
          <ReviewButtons
            reviewState={address?.last_review?.state}
            onApprove={approveAddressLead}
            onDecline={declineAddressLead}
          />
        )}
      </div>
      {address?.last_review?.state === 'disapproved' && (
        <RequestedReview description={address?.last_review?.description} />
      )}

      <AddressForm
        addressForm={addressForm}
        errors={errors.address_attributes as FieldErrors<AddressValidationSchema>}
        markFieldsAsRequired
        disableFields={disabled}
      />
    </div>
  );
};
